<footer class="bh-footer bg-white">
    <div class="content-padding">
        <div class="row no-negative-margin py-5">
            <div class="col-lg-4 col-xl-5 px-0 pe-5 bh-footer-company">
                <ion-img src="assets/images/kotak-logo.svg"
                         alt="kotak logo"></ion-img>
                <ion-text class="font-12 weight-500 d-block mt-3"
                          color="primary"> Distributors Empaneled with Kotak Mutual Fund enjoy Unparalleled benefits like ProStart, Cobranded Marketing Collaterals, and Monthly Business Snapshot! </ion-text>
            </div>
            <div class="col-lg-8 col-xl-7 px-0 bh-footer-links d-flex align-items-start justify-content-between">
                <div class="">
                    <ion-text class="weight-700 font-18 text-capitalize mb-4 d-block"
                              color="primary">Quick Links</ion-text>
                    <ion-text class="weight-600 font-14 text-capitalize mb-2 d-block cursor-pointer"
                              color="primary"><a href="https://www.kotakmf.com/aboutus">About Us</a></ion-text>
                    <ion-text class="weight-600 font-14 text-capitalize mb-2 d-block cursor-pointer"
                              color="primary"><a href="https://www.kotakmf.com">FAQ's</a></ion-text>
                    <ion-text class="weight-600 font-14 text-capitalize mb-2 d-block cursor-pointer"
                              color="primary"><a href="https://www.kotakmf.com/Information/forms-and-downloads">Forms & Downloads</a></ion-text>
                </div>
                <div class="contact-details">
                    <ion-text class="weight-700 font-18 text-capitalize mb-4 d-block"
                              color="primary">Reach out to us</ion-text>
                    <ion-text class="weight-600 font-14 mb-2 d-block"
                              color="primary">
                        <ion-icon class="me-2 vert-middle"
                                  src="assets/icon/tabs/feedback-footer.svg"
                                  alt="sms"></ion-icon>
                        <a class="cursor-pointer"
                           (click)="navigateWriteToUs()">Write to Us</a>
                    </ion-text>
                    <ion-text class="weight-600 font-14 mb-2 d-block"
                              color="primary">
                        <ion-icon class="me-2 vert-middle"
                                  src="assets/icon/footer/sms.svg"
                                  alt="sms"></ion-icon>
                        <a class="cursor-pointer break-all"
                           href="mailto:businesshub@kotak.com">businesshub@kotak.com</a>
                    </ion-text>
                    <ion-text class="weight-600 font-14 text-capitalize mb-2 d-block"
                              color="primary">
                        <ion-icon class="me-2 vert-middle"
                                  src="assets/icon/footer/call.svg"
                                  alt="call"></ion-icon>
                        <a class="cursor-pointer"
                           href="tel:18003091490">18003091490</a> / <a class="cursor-pointer"
                           href="tel:044-40229101">044-40229101</a>
                    </ion-text>
                </div>
                <div class="">
                    <ion-text class="weight-700 font-18 text-capitalize mb-4 d-block"
                              color="primary">Download the app</ion-text>
                    <div class="d-flex">
                        <a target="_blank"
                           rel="noopener"
                           href="https://play.google.com/store/apps/details?id=kotak.mutualfund&hl=en_SG">
                            <ion-img class="cursor-pointer"
                                     src="assets/icon/footer/playstore.svg"
                                     alt="playstore"></ion-img>
                        </a>
                        <a target="_blank"
                           href="https://apps.apple.com/in/app/kotak-business-hub/id1494282988"
                           rel="noopener">
                            <ion-img class="ms-3 cursor-pointer"
                                     src="assets/icon/footer/appstore.svg"
                                     alt="appstore"></ion-img>
                        </a>
                    </div>

                    <ion-text class="weight-700 font-14 text-capitalize mt-4 mb-2 d-block"
                              color="primary">Follow us on:</ion-text>
                    <div class="d-flex">
                        <a target="_blank"
                           rel="noopener"
                           class="cursor-pointer me-3"
                           href="https://www.facebook.com/KotakMF">
                            <ion-icon class="font-32"
                                      src="assets/icon/footer/Facebook.svg"></ion-icon>
                        </a>
                        <a target="_blank"
                           rel="noopener"
                           class="cursor-pointer me-3"
                           href="https://twitter.com/KotakMF">
                            <ion-icon class="font-32"
                                      src="assets/icon/footer/Twitter.svg"></ion-icon>
                        </a>
                        <a target="_blank"
                           rel="noopener"
                           class="cursor-pointer me-3"
                           href="https://www.linkedin.com/company/kotak-mutual-fund">
                            <ion-icon class="font-32"
                                      src="assets/icon/footer/LinkedIn.svg"></ion-icon>
                        </a>
                        <a target="_blank"
                           rel="noopener"
                           class="cursor-pointer me-3"
                           href="https://instagram.com/kotakmf/">
                            <ion-icon class="font-32"
                                      src="assets/icon/footer/Instagram.svg"></ion-icon>
                        </a>
                        <a target="_blank"
                           rel="noopener"
                           class="cursor-pointer me-3"
                           href="https://www.youtube.com/@KotakMahindraMutualFund">
                            <ion-icon class="font-32"
                                      src="assets/icon/footer/Youtube.svg"></ion-icon>
                        </a>
                        <a target="_blank"
                           rel="noopener"
                           class="cursor-pointer"
                           href="https://api.whatsapp.com/send?phone=919321884488&text=Hi">
                            <ion-icon class="font-32"
                                      src="assets/icon/footer/WhatsApp.svg"></ion-icon>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row no-negative-margin bh-footer-copyright py-2">
        <div class="col-4 px-0 pe-4">
            <ion-text class="text-white text-capitalize font-14 weight-400">© Kotak Mutual Fund {{this.systemService.currentYear}}</ion-text>
        </div>
        <div class="col-8 px-0 text-start ps-3">
            <ion-text class="text-uppercase font-12 weight-400 text-white">MUTUAL FUND INVESTMENTS ARE SUBJECT TO MARKET RISKS, READ ALL SCHEME RELATED DOCUMENTS CAREFULLY.</ion-text>
        </div>
    </div>
</footer>